import type { FailureWithSubjectDidName } from "@/src/components/organisms/InvalidSubjectDidsDialog/InvalidSubjectDidsDialog.types";

export const mapInvalidSubjectDids = (
    failures: FailureWithSubjectDidName[]
) => {
    const uniqueInvalidSubjectDids = failures?.reduce(
        (acc, failure) => {
            const existingSubject = acc.find(
                (item) => item.subjectId === failure.subjectId
            );

            if (existingSubject) {
                if (
                    !existingSubject.indicators.some(
                        (indicator) => indicator.name === failure.indicator.name
                    )
                ) {
                    existingSubject.indicators.push(failure.indicator);
                }
            } else {
                acc.push({
                    ...failure,
                    indicators: [failure.indicator],
                });
            }
            return acc;
        },
        [] as ((typeof failures)[number] & {
            indicators: { name: string; path: string }[];
        })[]
    );

    return uniqueInvalidSubjectDids;
};

export default mapInvalidSubjectDids;
